import React from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import SettingForm from 'components/srv/setting/settingForm';
import Message from 'components/parts/message';
import { getProgramSetting, updateProgramSetting } from 'actions/programSettingAction';
import { setBreadcrumb } from 'actions/breadcrumbAction';
import { clearMessage, setMessage } from 'actions/messageAction';
import { consoleLogger } from 'helpers';
import { lang } from 'lang';

/**
 * 調整プログラム編集画面
 */
const SrvProgramEdit = (props) => {
  const { msg, error } = lang;
  const { id } = props.match.params;
  // リクエストキャンセルトークンを取得
  const cancelToken = axios.CancelToken.source();
  const { register, handleSubmit, formState, errors } = useForm({mode: 'onChange'});
  const dispatch = useDispatch();
  // グローバルステートから対象の調整プログラム設定を取り出す
  const programSettingState = useSelector(
    (state) => state.programSetting.items.filter((item) => item.product_cd === id)
  );
  // ブラウザでコンポーネントが初めて表示される時だけ実行される(≒componentDidMount)
  React.useEffect(() => {
    // メッセージクリア
    dispatch(clearMessage());
    // パンくずリストにプロダクトコードをセット
    dispatch(setBreadcrumb(id));
    // 対象の調整プログラム設定を取得する
    getData(id, cancelToken);
    return () => { cancelToken.cancel('unmounted component.'); };
  }, []);

  // 対象の調整プログラム設定を取得する
  const getData = async (id, cancelToken) => {
    try {
      // 対象の調整プログラム設定を取得する
      await dispatch(
        await getProgramSetting(id, cancelToken)
      ).then((result) => {
        // Success
        if (result.status !== 200) {
          // Not Exist
          if (result.status === 404) {
            dispatch(setMessage('info', msg.custom_file.not_exist));
          // Error
          } else {
            dispatch(setMessage('danger', error.custom_file.get + `\n${result.errcode}`));
          }
        }
      });
    } catch (e) {
      consoleLogger('Fail get program setting detail.', e);
    }
  };

  // 調整プログラムがない場合
  if (programSettingState.length === 0) {
    return <div className="col-10 pt-3 pb-3"><Message/></div>;
  } else {
    // 更新ボタンが押されたときに実行される
    const onSubmit = async params => {
      // メッセージクリア
      dispatch(clearMessage());
      await dispatch(
        // 調整プログラム設定を更新する
        await updateProgramSetting(programSettingState[0].product_cd, params)
      ).then((result) => {
        // Success
        if (result.status === 200) {
          props.history.replace({
            pathname: '/srv/settings',
            state: { 
              keepMessage: true,  // 一覧画面表示時にメッセージを残す
              message: {
                type: 'success',
                msg: msg.custom_file.update,
              }
            }
          });
        // Warning
        } else if (result.status === 404) {
          dispatch(setMessage('danger', msg.custom_file.not_exist));
        // Error
        } else {
          dispatch(setMessage('danger', error.custom_file.update + `\n${result.errcode}`));
        }
      });
    };
    return (
      <>
        <div className="col-10 pt-3 pb-3">
          <Message/>
          <SettingForm isUpdate={true} register={register} values={programSettingState[0]} onSubmit={handleSubmit(onSubmit)} formState={formState} errors={errors}/>
        </div>
      </>
    );
  }
};
SrvProgramEdit.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object
};
SrvProgramEdit.defaultProps = {
  match: {
    params: {
      id: '',
    }
  }
};
export default SrvProgramEdit;